module.exports = __webpack_public_path__ + "static/black-friday-e5e86b2917dab38b33ce9e829f834512.png";